import { render, staticRenderFns } from "./TheContacto.vue?vue&type=template&id=522623da&scoped=true&"
import script from "./TheContacto.vue?vue&type=script&lang=js&"
export * from "./TheContacto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522623da",
  null
  
)

export default component.exports